const PERMISSION_KEY= "company:company";
const PAGE_URL = {
    EXTRACT_FINANCE_STATEMENT_PAGE: "/admin/company/extract-finance-statement"
}

export {PERMISSION_KEY, PAGE_URL}

